import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

const countFontSize = 24;
const riskLevelFontSize = 20;

export const useTopBarTileStyles = () => {
    const theme = useTheme();
    const standaloneValue = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 1,
        lineHeight: 1.2,
        color: theme.palette.primary.dark,
    };

    return createSxStyles({
        // Every standalone tile value shares one look so the tiles in a row read as one row.
        value: { ...standaloneValue, fontSize: theme.typography.pxToRem(countFontSize) },
        // A risk level is a word plus a score rather than a single figure, so it sits one step down to fit the tile.
        riskValue: { ...standaloneValue, fontSize: theme.typography.pxToRem(riskLevelFontSize) },
        // A clickable count keeps the link's own color, so only the typography is shared.
        linkValue: { fontSize: theme.typography.pxToRem(countFontSize), lineHeight: 1.2 },
    });
};
